import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { ApiService } from '@api/api.service';
import { ModalService } from '@shared/modal/modal.service';
import { TableActions } from '@shared/table/actions/action';
import { TableConfig } from '@shared/types/table';
import { AccountNotesDatasource } from './account-notes.datasource';

@Component({
  selector: 'rav-account-notes',
  templateUrl: './account-notes.component.html',
  styleUrls: ['./account-notes.component.scss']
})
export class AccountNotesComponent implements OnInit {
  @Input() accountId: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isNewNoteVisible = false;
  formGroup: FormGroup;
  dataSource: AccountNotesDatasource;
  message: string;
  messageType: string;

  get calloutClass(): string {
    return `small ${this.messageType} callout margin-top-1`;
  }

  tableConfig: TableConfig = {
    columns: [{ key: 'created_at' }, { key: 'note' }, { key: 'office_user_id', header: 'logged by' }],
    mobileSettings: {
      titleKeys: ['note'],
      subtitleKey: 'created_at',
      subtitleHeader: 'Created',
      preventFixedPaginator: true
    },
    actions: [TableActions.addNotes],
    isSearchable: false,
    // Added fixed page size as the page size dropdown was behind the reveal and was unselectable.
    fixedPageSize: 25,
    preventUrlParamHandling: true
  };

  constructor(
    private injector: Injector,
    private formBuilder: FormBuilder,
    private api: ApiService,
    private modal: ModalService
  ) {}

  ngOnInit() {
    this.dataSource = new AccountNotesDatasource(this.injector, this.accountId);
    this.buildFormGroup();
    this.modal.open.subscribe((data) => {
      this.message = null;
      if (data.modalId === 'accountNotes') this.dataSource.reloadData.emit();
    });
  }

  buildFormGroup(): void {
    this.formGroup = this.formBuilder.group({
      note: new FormControl('')
    });
  }

  /**
   * Resets the form group and hide it.
   */
  resetNewNote(): void {
    this.buildFormGroup();
    this.isNewNoteVisible = false;
  }

  onActionsTriggered(action: any): void {
    this.message = null;
    switch (action.name) {
      case TableActions.addNotes.name:
        this.isNewNoteVisible = true;
        break;
    }
  }

  saveNotes(note: string): void {
    this.api.accounts.byId.notes.post(this.accountId, { note }).subscribe(
      () => {
        this.resetNewNote();
        this.dataSource.reloadData.emit();
        this.message = 'Note has been added successfully.';
        this.messageType = 'success';
      },
      (error) => {
        this.api.onFormError(error, this.formGroup);
      }
    );
  }
}
